<template>
  <div class="d-grid grid-col-sm-1-1 grid-col-lg-1-1-1 gap-5 align-start">
    <BaseCard :title="t.sections['chertezhi-i-dokumenty']">
      <template slot="action" v-if="edit">
        <BaseInput
          type="switch"
          class="mt-n3 mr-n3"
          v-model="documents"
          @input="config['schemes'] = documents, config['documents'] = documents"
        />
      </template>
      <BaseInput
        type="switch"
        :label="t['schemes_documents-sections']['chertezhi']"
        v-model="config['schemes']"
        :view-value="m[config['schemes'] ? 'yes' : 'no']"
        :view="!edit"
      />
      <BaseInput
        type="switch"
        :label="t['schemes_documents-sections']['dokumenty']"
        v-model="config['documents']"
        :view-value="m[config['documents'] ? 'yes' : 'no']"
        :view="!edit"
      />
    </BaseCard>
    <BaseCard :title="t.sections['materialy-i-tseny']">
      <template slot="action" v-if="edit">
        <BaseInput
          type="switch"
          class="mt-n3 mr-n3"
          v-model="prices"
          @input="config['work_type_prices'] = prices, config['extra_work_price'] = prices"
        />
      </template>
      <BaseInput
        type="switch"
        :label="t.sections['materialy-i-tseny']"
        v-model="config['work_type_prices']"
        :view-value="m[config['work_type_prices'] ? 'yes' : 'no']"
        :view="!edit"
      />
      <BaseInput
        type="switch"
        :label="t.sections['price_extra']"
        v-model="config['extra_work_price']"
        :view-value="m[config['extra_work_price'] ? 'yes' : 'no']"
        :view="!edit"
      />
    </BaseCard>
    <BaseCard>
      <BaseInput
        type="switch"
        :label="t['project_client-labels']['otvetstvennoe-litso-po-kontraktu']"
        v-model="config['responsible_person']"
        :view-value="m[config['responsible_person'] ? 'yes' : 'no']"
        :view="!edit"
      />
      <BaseInput
        type="switch"
        :label="t['planned_resources-subscribers']['subscriber']"
        v-model="config['subscribers']"
        :view-value="m[config['subscribers'] ? 'yes' : 'no']"
        :view="!edit"
      />
    </BaseCard>
    <div class="fixedBtn">
      <BaseTooltip
        v-if="edit"
        :tooltip="localStorage.translations.pages.common['buttons']['sohranit']"
      >
        <BaseButton
          :disabled="!navigationGuardianActive"
          @click="onSave"
          round
          icon_only
          size="60"
          default_icon="button-save"
        />
      </BaseTooltip>
      <BaseTooltip
        v-else
        :tooltip="localStorage.translations.pages.common['buttons']['redaktirovat']"
      >
        <BaseButton @click="onEdit" round size="60" icon_only default_icon="button-edit" />
      </BaseTooltip>
    </div>
  </div>
</template>

<script>
import BaseCard from 'components/base/BaseCard'
import BaseInput from 'components/base/BaseInput'
import { mapActions, mapGetters } from 'vuex'
export default {
  name: 'settingCompanyProject',
  components: { BaseInput, BaseCard },
  data: () => ({
    config: new Object({
      schemes: false,
      documents: false,
      work_type_prices: false,
      extra_work_price: false,
      responsible_person: false,
      subscribers: false,
    }),
    documents: false,
    prices: false,
  }),
  computed: {
    ...mapGetters('navigationGuardian', ['navigationGuardianActive']),
    t() {
      return this.localStorage.translations.pages['sales_project']
    },
    m() {
      return this.localStorage.mobile.pages['mob_modal'].common
    },
    n() {
      return this.localStorage.translations.pages.common.notifications
    },
    edit() {
      return this.$route.name === 'SettingCompanyProjectEdit'
    },
  },
  watch: {
    '$route.name'() {
      this.onCheckChange({ overwrite: true })
    },
    config: {
      handler() {
        if (this.edit) this.onCheckChange({ overwrite: false })
        this.formatGroupData()
      },
      deep: true,
    }
  },
  created() {
    this.onLoadData()
  },
  methods: {
    ...mapActions('commonConfig', ['onCommonConfigSettings', 'onCommonConfigSettingsUpdate']),
    ...mapActions('navigationGuardian', ['onNavigationGuardianCheck']),
    onCheckChange({ overwrite }) {
      this.onNavigationGuardianCheck({
        data: { companyProject: this.config },
        overwrite,
      })
    },
    async onLoadData() {
      await this.onCommonConfigSettings({ name: 'project_settings' })
        .then((res) => {
          this.formatData(res.data)
        })
        .catch(() => {
          this.$store.dispatch(
            'popup/onMessage',
            { message: this.n['oshibka'], IsError: false },
            { root: true },
          )
        })
    },
    formatData(data) {
      for (let i in this.config) {
        this.config[i] = Boolean(Number(data[i]))
      }
      this.formatGroupData()
    },
    formatGroupData() {
      this.documents = this.config.schemes || this.config.documents
      this.prices = this.config.work_type_prices || this.config.extra_work_price
    },
    async onSave() {
      let data = {}
      for (let i in this.config) {
        data[i] = Number(this.config[i])
      }
      await this.onCommonConfigSettingsUpdate({
        name: 'project_settings',
        data: data,
      })
        .then((res) => {
          this.formatData(res.data)
          this.onCheckChange({ overwrite: true })
          this.$store.dispatch(
            'popup/onMessage',
            { message: this.n['izmeneniya-uspeshno-sohraneny'], IsError: false },
            { root: true },
          )
          setTimeout(() => {
            this.onEdit()
          }, 300)
        })
        .catch(() => {
          this.$store.dispatch(
            'popup/onMessage',
            { message: this.n['oshibka'], IsError: false },
            { root: true },
          )
        })
    },
    onEdit() {
      this.$router.push({
        name: this.edit ? 'SettingCompanyProject' : 'SettingCompanyProjectEdit',
      })
    },
  },
}
</script>

<style scoped lang="scss">
.d-grid {
  max-width: 2100px;
}
</style>